export default () => {
  const ua = window.navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones
    but Trident does not include edge
  */
  return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
};
